import { render, staticRenderFns } from "./garden_leave1.vue?vue&type=template&id=658e4e39&scoped=true&"
import script from "./garden_leave1.vue?vue&type=script&lang=js&"
export * from "./garden_leave1.vue?vue&type=script&lang=js&"
import style0 from "./garden_leave1.vue?vue&type=style&index=0&id=658e4e39&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658e4e39",
  null
  
)

export default component.exports